import React from 'react'
import { FormattedMessage } from "react-intl"
import { toAbsoluteUrl } from '../../../../../_metronic/_helpers'

type SendType = 'whatsapp' | 'email' | 'sms' | string

export function TypeColumnFormatter(cellContent: SendType): JSX.Element | null {
  const prefix = 'notifications-send-type'

  const getResultType = (sendType: SendType): JSX.Element | null => {
    switch (sendType) {
      case 'whatsapp':
        return (
          <div className="font-weight-bolder font-size-lg text-nowrap" style={{ color: '#28a745' }}>
            <img
              src={toAbsoluteUrl('/media/svg/Whatsapp.svg')}
              alt="whatsapp"
              className="mr-2 w-20px h-20px"
            />
            <FormattedMessage id={`${prefix}-whatsapp`} defaultMessage="Whatsapp" />
          </div>
        )

      case 'email':
        return (
          <div className="font-weight-bolder font-size-lg text-nowrap" style={{ color: '#FF8303' }}>
            <img
              src={toAbsoluteUrl('/media/svg/Mail_orange.svg')}
              alt="email"
              className="mr-2 w-20px h-20px"
            />
            <FormattedMessage id={`${prefix}-email`} defaultMessage="Email" />
          </div>
        )

      case 'sms':
        return (
          <div className="font-weight-bolder font-size-lg text-nowrap" style={{ color: '#0C8298' }}>
            <img
              src={toAbsoluteUrl('/media/svg/SMS_brandColor.svg')}
              alt="sms"
              className="mr-2 w-20px h-20px"
            />
            <FormattedMessage id={`${prefix}-sms`} defaultMessage="SMS" />
          </div>
        )

      default:
        return null
    }
  }

  return getResultType(cellContent)
}